/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {InfoCardBasic, InfoCardTitle, InfoCardButtons, InfoCardButtonsCentered, InfoCardAcceptButton, InfoCardCloseButton, InfoCardCustomIcon, InfoCardCentered, InfoCardCustomImage, InfoCardCustomImageCentered} from 'Docs/uilib/components/info-card/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "InfoCard (default)"
    }), "\n", _jsx(InfoCardBasic, {}), "\n", _jsx(_components.h3, {
      children: "InfoCard with a title"
    }), "\n", _jsx(InfoCardTitle, {}), "\n", _jsx(_components.h3, {
      children: "InfoCard with Buttons"
    }), "\n", _jsx(InfoCardButtons, {}), "\n", _jsx(InfoCardButtonsCentered, {}), "\n", _jsx(_components.p, {
      children: "Each button can be used independently."
    }), "\n", _jsx(InfoCardAcceptButton, {}), "\n", _jsx(InfoCardCloseButton, {}), "\n", _jsx(_components.h3, {
      children: "InfoCard accepts a custom icon"
    }), "\n", _jsx(InfoCardCustomIcon, {}), "\n", _jsx(_components.h3, {
      children: "InfoCard centered content"
    }), "\n", _jsx(InfoCardCentered, {}), "\n", _jsx(_components.h3, {
      children: "InfoCard custom image"
    }), "\n", _jsx(InfoCardCustomImage, {}), "\n", _jsx(_components.h3, {
      children: "InfoCard custom image centered"
    }), "\n", _jsx(InfoCardCustomImageCentered, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
